/* tslint:disable */

declare var Object: any;
export interface SFPayPeriodInterface {
  "id"?: number;
}

export class SFPayPeriod implements SFPayPeriodInterface {
  "id": number;
  constructor(data?: SFPayPeriodInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPayPeriod`.
   */
  public static getModelName() {
    return "SFPayPeriod";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPayPeriod for dynamic purposes.
  **/
  public static factory(data: SFPayPeriodInterface): SFPayPeriod{
    return new SFPayPeriod(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPayPeriod',
      plural: 'SFPayPeriods',
      path: 'SFPayPeriods',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPayPeriod.ts